<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="epig"> </p>
<p class="EP">No one should come to New York to live unless he is willing to be lucky.</p>
<p class="EPC-1">—E. B. White, <span class="ePub-I-1">Here Is New York </span>(1949)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?665e544f